<script setup lang="ts">
import type { NuxtError } from "#app";
import * as Sentry from "@sentry/nuxt";

const props = defineProps<{ error: NuxtError }>();

// Report to Sentry from Vue setup (valid composable context)
if (props.error) {
  try {
    Sentry.captureException(props.error);
  } catch {
    // Sentry not initialized or capture failed
  }
}
</script>

<template>
  <div class="flex min-h-screen flex-col items-center justify-center p-6">
    <h1 class="text-xl font-semibold">Error</h1>
    <p class="mt-2 text-neutral-600">An error has occurred</p>
    <NuxtLink
      to="/"
      class="mt-6 rounded bg-neutral-900 px-4 py-2 text-white hover:bg-neutral-800"
    >
      Go back home
    </NuxtLink>
  </div>
</template>
